/* eslint-disable react/no-array-index-key */
import React, { FunctionComponent, useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DTETypeahead from 'components/DTETypeahead/DTETypeahead';
import { FormattedDTE } from '@upstart/harmony/lib/legos/dtEntitiesTypes';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { isDealerTrackDMSConfigured } from 'util/dmsUtils';
import dtEntitiesActions from '../../redux/dtEntities/actions';

interface DteResponse {
  dtEntities: FormattedDTE[];
}

interface Props {
  dealer: Dealer;
  actions: ReturnType<typeof bindActionCreators>;
  onChange: (value: any, errorSchema: any) => void;
  dealerTrackEntities: DteResponse;
  schema: { dealerId: string; dmsType: string; dmsConfig: any };
  value: string | undefined;
}

const DealerTrackMatchComponent: FunctionComponent<Props> = props => {
  const { actions, onChange } = props;
  const { dealerId, dmsType, dmsConfig } = props.schema;

  const dtEntities = (props.dealerTrackEntities || {}).dtEntities || [];
  const dteMap = new Map<string | undefined, FormattedDTE>(
    dtEntities.map(dte => [dte.id, dte]),
  );

  useEffect(() => {
    if (
      isDealerTrackDMSConfigured({
        dmsType,
        dmsConfig,
      })
    ) {
      actions.dtEntityRequest({ dealerId });
    }
  }, [dealerId, dmsType, dmsConfig]);

  return (
    <DTETypeahead
      dtEntities={dtEntities?.filter(
        dte => dte.category === 'Aftermarket Option',
      )}
      selectedDTE={dteMap.get(props?.value)}
      onChange={(dte: FormattedDTE[]) => onChange(dte?.[0]?.id, null)}
      recenterClearButton
    />
  );
};

const mapStateToProps = ({ dtEntities }: { dtEntities: DteResponse }) => ({
  dealerTrackEntities: dtEntities,
});

const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  actions: bindActionCreators(
    {
      ...dtEntitiesActions,
    },
    dispatch,
  ),
});

const ConnectedWidget = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DealerTrackMatchComponent);

const DealerTrackMatch = (props: any) => <ConnectedWidget {...props} />;

export default DealerTrackMatch;
